import * as React from 'react'

import { Box, List, Row, Title } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import Upgrade from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { Resources } from 'modules/expenses/hooks/useExpensesCustomization'
import { missingFeatureRequestReason } from 'modules/finance/lib/missingFeatureRequestReason'
import { UpsellingKit } from 'modules/upselling_kit/components'

import ExpenseTypeCard from './ExpenseTypeCard'

interface Props {
  hasExpensesFormCustomizationFeature: boolean
  hasPerDiemsFeature: boolean
}

const FormsSection = ({ hasExpensesFormCustomizationFeature, hasPerDiemsFeature }: Props) => {
  const { navigation } = useNavigation()
  const [showUpgradeModalFlow, setShowUpgradeModalFlow] = React.useState(false)
  const { company } = useCurrentSession()

  const expensesFormTypesList = [
    {
      id: 'expense',
      label: i18n.t('expenses_v2.settings.forms.types.expense'),
      route: navigation.settings.expenses.expensesForms.fields.fullPath({
        resource_type: Resources.expense,
      }),
    },
    {
      id: 'mileage',
      label: i18n.t('expenses_v2.settings.forms.types.mileage'),
      route: navigation.settings.expenses.expensesForms.fields.fullPath({
        resource_type: Resources.mileage,
      }),
    },
    ...(hasPerDiemsFeature
      ? [
          {
            id: 'perdiem',
            label: i18n.t('expenses_v2.settings.forms.types.per_diem'),
            route: navigation.settings.expenses.expensesForms.fields.fullPath({
              resource_type: Resources.perdiem,
            }),
          },
        ]
      : []),
  ]

  return (
    <>
      <Box flexGrow>
        <Row>
          <Row.Col halfWidth>
            <Title
              variant="400"
              title={i18n.t('expenses_v2.settings.forms.title')}
              description={i18n.t('expenses_v2.settings.forms.description')}
              illustration="document-folder-disorder-list"
            />
            {!hasExpensesFormCustomizationFeature && (
              <Upgrade.Small
                title={i18n.t('expenses_v2.settings.forms.upgrade')}
                action={{
                  type: 'know_more',
                  onClick: () => {
                    setShowUpgradeModalFlow(true)
                  },
                }}
              />
            )}
          </Row.Col>
          <Row.Col halfWidth>
            <List>
              {expensesFormTypesList.map((type) => (
                <List.Item key={type.id}>
                  <ExpenseTypeCard label={type.label} route={type.route} resourceType={type.id} />
                </List.Item>
              ))}
            </List>
          </Row.Col>
        </Row>
      </Box>
      {showUpgradeModalFlow && (
        <UpsellingKit.ProductModal
          isOpen={showUpgradeModalFlow}
          onClose={() => setShowUpgradeModalFlow(false)}
          requestSource="Expenses settings form"
          featureRequested={Features.expenses_form_customization}
          moduleRequested={AvailableModules.expenses}
          requestReason={missingFeatureRequestReason(company)}
          pageSource="expenses_settings_form_customization"
        />
      )}
    </>
  )
}

export default observer(FormsSection)
